const formatIcsDate = (date) => {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
};
export const generateAndDownloadIcs = (event) => {
    const { title, description, startTime, endTime, location = '', eventName = 'event.ics' } = event;
    const icsContent = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Ziphy//Ziphy//EN',
        'BEGIN:VEVENT',
        `UID:${Date.now()}@ziphy.com`,
        `DTSTAMP:${formatIcsDate(new Date())}`,
        `DTSTART:${formatIcsDate(startTime)}`,
        `DTEND:${formatIcsDate(endTime)}`,
        `SUMMARY:${title}`,
        `DESCRIPTION:${description}`,
        `LOCATION:${location}`,
        'END:VEVENT',
        'END:VCALENDAR',
    ].join('\n');
    // Create Blob (binary object) from text content
    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    // Create temporary link for downloading the file
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', eventName);
    // Add link to DOM, click on it and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // Free memory
    URL.revokeObjectURL(link.href);
};
